<div class="modal-header text-center">
<!--  <button type="button" class="d-none">-->
<!--  </button>-->
  <h1 class="modal-title mx-auto" id="modal-basic-title">
    <ng-content select="app-modal-header"></ng-content>
  </h1>
<!--  <button-->
<!--    type="button"-->
<!--    class="close"-->
<!--    (click)="activeModal.dismiss('Cross click')"-->
<!--  >-->
<!--    <span aria-hidden="true"><app-icon icon="times"></app-icon></span>-->
<!--  </button>-->
</div>
<div class="modal-body" autofocus>
  <ng-content select="app-modal-body"></ng-content>
</div>
<div class="modal-footer">
  <ng-content select="app-modal-footer"></ng-content>
</div>
